import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import { initializeApp } from 'firebase/app';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

const initialValues = {
  email: '',
  // email: 'admin@demo.com',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

const firebaseConfig = {
  apiKey: "AIzaSyDnyomA90Kg1yrELokYx02jOHRs_Cm7LGc",
  authDomain: "gj08-6e7ea.firebaseapp.com",
  projectId: "gj08-6e7ea",
  storageBucket: "gj08-6e7ea.appspot.com",
  messagingSenderId: "527457566258",
  appId: "1:527457566258:web:da78475eabd5ae580b062b",
  measurementId: "G-KGVQ6TS2WV"
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(firebaseApp);

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      
      setTimeout(() => {
        resetPasswordOnFirebase(values.email)
      }, 1000)

    },
  })

  // Firebase methods - start

  const resetPasswordOnFirebase = (email: string) => {
    sendPasswordResetEmail(firebaseAuth, email)
      .then(() => {
        // Password reset email sent!
        // ..
        setHasErrors(false)
        setLoading(false)
        console.log(`Password reset email has been sent to your email address.`);
        formik.setStatus(`Password reset email has been sent to your email address.`)
      })
      .catch((error) => {
        switch (error.code) {
          case 'auth/user-not-found':
            console.log(`User with this email: ${email} doesn't exist.`);
            formik.setStatus(`User with this email: ${email} doesn't exist.`)
            setHasErrors(true)
            setLoading(false);
            break;
          case 'auth/invalid-email':
            console.log(`Email address ${email} is invalid.`);
            formik.setStatus(`Email address ${email} is invalid.`)
            setHasErrors(true)
            setLoading(false);
            break;
          case 'auth/operation-not-allowed':
            console.log(`Error during sign in.`);
            formik.setStatus(`Error during sign in.`)
            setHasErrors(true)
            setLoading(false);
            break;
          case 'auth/weak-password':
            console.log('Password is not strong enough. Add additional characters including special characters and numbers.');
            formik.setStatus('Password is not strong enough. Add additional characters including special characters and numbers.')
            setHasErrors(true)
            setLoading(false);
            break;
          default:
            console.log(error.message);
            formik.setStatus(error.message)
            setHasErrors(true)
            setLoading(false);
            break;
        }
      });
  }

  // Firebase methods - end


  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-5'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Forgot Password ?</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray fw-bold fs-4'>Enter your email to reset your password.</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              Sorry, looks like there are some errors detected, please try again.
            </div>
          </div>
        )}

        {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>Sent password reset. Please check your email</div>
          </div>
        )}
        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
          <input
            type='email'
            placeholder=''
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.email}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
          >
            <span className='indicator-label'>Submit</span>
            {loading && (
              <span className='indicator-progress'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Cancel
            </button>
          </Link>{' '}
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
